import { GlowShadow } from '../../../../Components/GlowShadow'
import * as S from './styles'

export const HeroSection = () => {
  return (
    <S.Wrapper>
      <h2>
        Conectamos pessoas, ideias e tecnologia para transformar negócios.
      </h2>
      <p>
        Há mais de 26 anos, a Bindflow cria soluções digitais que unem inovação, eficiência e propósito — impulsionando empresas a operar de forma mais inteligente.
      </p>
      <div style={{
        position: 'relative',
        height: '53px',
        marginBottom: '48px'
      }}>
        <GlowShadow />
      </div>

      <S.Content>

      </S.Content>
    </S.Wrapper>
  )
}
